import { render, staticRenderFns } from "./GameBuy.vue?vue&type=template&id=def498f2&scoped=true&"
import script from "./GameBuy.vue?vue&type=script&lang=js&"
export * from "./GameBuy.vue?vue&type=script&lang=js&"
import style0 from "./GameBuy.vue?vue&type=style&index=0&id=def498f2&scoped=true&lang=css&"
import style1 from "./GameBuy.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def498f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VApp,VBtn,VDataTable,VIcon,VSelect})
